var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerChargingStation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149,
    cy: 150.5,
    fill: "#ffffff",
    id: "svg_12",
    rx: 143,
    ry: 144.5,
    stroke: "#007f00",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    transform: "matrix(8.20321 0 0 7.74648 -13.4326 -4.6409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.31,26.25l2.11,-3.35l-1.27,0l0,-2.52l-2.08,3.36l1.24,0l0,2.51zm-2.8,-8.09l6.45,0l0,-5.47l-6.45,0l0,5.47zm0,8.91l6.45,0l0,-7.48l-6.45,0l0,7.48zm-1.44,1.44l0,-15.82c0,-0.38 0.15,-0.72 0.43,-1c0.29,-0.29 0.63,-0.43 1.01,-0.43l6.45,0c0.38,0 0.71,0.14 1,0.43c0.29,0.28 0.43,0.62 0.43,1l0,6.9l1.56,0c0.33,0 0.61,0.12 0.85,0.35c0.23,0.24 0.35,0.52 0.35,0.85l0,5.25c0,0.35 0.14,0.64 0.42,0.87c0.28,0.23 0.6,0.35 0.97,0.35c0.37,0 0.71,-0.12 1.03,-0.35c0.32,-0.23 0.48,-0.52 0.48,-0.87l0,-9.27l-0.36,0c-0.21,0 -0.38,-0.07 -0.51,-0.21c-0.14,-0.14 -0.21,-0.31 -0.21,-0.51l0,-2.16l0.48,0l0,-1.2l0.72,0l0,1.2l0.96,0l0,-1.2l0.71,0l0,1.2l0.48,0l0,2.16c0,0.2 -0.07,0.37 -0.2,0.51c-0.14,0.14 -0.31,0.21 -0.52,0.21l-0.35,0l0,9.26c0,0.69 -0.28,1.28 -0.82,1.76c-0.54,0.48 -1.17,0.72 -1.9,0.72c-0.7,0 -1.31,-0.24 -1.82,-0.72c-0.51,-0.48 -0.76,-1.07 -0.76,-1.75l0,-5.25l-1.56,0l0,7.72l-9.32,0z",
    fill: "#007f00",
    id: "svg_1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerChargingStation);
export default __webpack_public_path__ + "static/media/marker-charging-station.fd33bc0d73a80bfa77ab23e43adc44d6.svg";
export { ForwardRef as ReactComponent };